import { render, staticRenderFns } from "./VisitType.vue?vue&type=template&id=065c687e&"
import script from "./VisitType.vue?vue&type=script&lang=js&"
export * from "./VisitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065c687e')) {
      api.createRecord('065c687e', component.options)
    } else {
      api.reload('065c687e', component.options)
    }
    module.hot.accept("./VisitType.vue?vue&type=template&id=065c687e&", function () {
      api.rerender('065c687e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outputs/VisitType.vue"
export default component.exports